/*
  VBRNTT event list — the card list on chapter and fair pages.

  The server renders every upcoming card, so the page is complete without
  JS. This script only:
  - sorts cards soonest-first (Liquid can't sort metaobjects by a date field)
  - re-checks expiry, because the rendered page may be cached past an event
  - shows the empty message when nothing is left

  Expiry rule, same as the city scroller: a card is hidden when
  Date.now() >= data-expires * 1000. data-expires is the end of the event's
  last day in shop time. Never compare it against the visitor's local
  start-of-day.
*/
(() => {
  if (customElements.get('vbrntt-event-list')) return;

  class VbrnttEventList extends HTMLElement {
    connectedCallback() {
      this.cardList = this.querySelector('[data-cards]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));

      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.sortCards();
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    /* Soonest first; ties broken by expiry, then server order. */
    sortCards() {
      if (!this.cardList) return;
      this.cards
        .map((card, index) => ({
          card,
          index,
          start: Number(card.dataset.start) || 0,
          expires: Number(card.dataset.expires) || 0,
        }))
        .sort((a, b) => a.start - b.start || a.expires - b.expires || a.index - b.index)
        .forEach(({ card }) => this.cardList.appendChild(card));
    }

    refresh() {
      const now = Date.now();
      let visible = 0;
      this.cards.forEach((card) => {
        const expired = now >= Number(card.dataset.expires) * 1000;
        card.hidden = expired;
        if (!expired) visible += 1;
      });
      if (this.emptyEl) this.emptyEl.hidden = visible > 0;
    }

    /* A tab left open past an event's end catches up when it's revisited. */
    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.refresh();
    }
  }

  customElements.define('vbrntt-event-list', VbrnttEventList);
})();
